import React, { Component, useState, useRef, useEffect } from "react";
import AuthHeader from "./AuthHeader";
import { Link, Navigate } from "react-router-dom";
import Cookie from "js-cookie";
import moment from "moment";
import { Row, Col, Button, Checkbox, Form, Input, Modal, Select, Typography } from "antd";

function Login(props) {
  const [loginInformation, setLoginInformation] = useState({ email: "", password: "", remember_me: false });
  const [supportCompany, setSupportCompany] = useState(null);
  const [showSupportModal, setShowSupportModal] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [capsLockWarning, setCapsLockWarning] = useState(false);

  const supportCompaniesSelectRef = useRef(null);

  let SubmitLogin = async () => {
    if (loginInformation.email.length === 0) return props.MakeNotification("info", "Please enter your email.");
    if (loginInformation.password.length === 0) return props.MakeNotification("info", "Please enter your password.");

    let hardware_details = { os: "Unknown OS", os_details: "", browser: "Unknown Browser", screen: { height: 0, width: 0 } };
    if (navigator.appVersion.indexOf("Win") !== -1) hardware_details.os = "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) hardware_details.os = "MacOS";
    if (navigator.appVersion.indexOf("X11") !== -1) hardware_details.os = "UNIX";
    if (navigator.appVersion.indexOf("Linux") !== -1) hardware_details.os = "Linux";
    if (navigator.appCodeName.indexOf("Moz") !== -1) hardware_details.browser = "Mozilla Firefox";
    if (navigator.appCodeName.indexOf("Chrome") !== -1) hardware_details.browser = "Google Chrome";
    if (navigator.appCodeName.indexOf("Edge") !== -1) hardware_details.browser = "Microsoft Edge";
    if (navigator.appCodeName.indexOf("Explorer") !== -1) hardware_details.browser = "Internet Explorer";
    if (navigator.appCodeName.indexOf("Opera") !== -1) hardware_details.browser = "Opera";

    hardware_details.os_details = navigator.oscpu;
    hardware_details.screen.width = window.screen.availWidth;
    hardware_details.screen.height = window.screen.availHeight;
    //
    let response = await props.AxiosRequest("/api/user/login", {
      ...loginInformation,
      preferred_company: supportCompany,
      hardware_details: JSON.stringify(hardware_details),
    });
    if (response?.data.status === "info") {
      props.MakeNotification("info", response?.data.message || "Please select the company you wish to log into.");
      setCompanies(
        response?.data?.data.map((m) => {
          return { label: m.name, value: m.company_id };
        }),
      );
      setShowSupportModal(true);
      setTimeout(() => {
        supportCompaniesSelectRef?.current?.focus();
      }, 150);
      return;
      //focus dropdown
    }
    if (response?.data.status === "success") {
      Cookie.set("x-access-token", response?.data.token);
      Cookie.set("security-settings", JSON.stringify(response?.data.security_settings));
      Cookie.set("x-access-token-expiration", moment().add(response?.data.expiration_in_seconds, "seconds"));
      props.setSecuritySettings(response?.data.security_settings);
      props.setAuthToken(response?.data.token);
      props.setTokenExpirationDate(moment().add(response?.data.expiration_in_seconds, "seconds"));
      props.setRelogRequired(false);
      if ("caches" in window) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }
      setTimeout(() => {
        window.location.href = window.location.protocol + "//" + window.location.host + "/clients"; //we do a hard browser setting of the location so that if there are any new updates, a logout and login will cause the broswer to lose it's cache and get the updates.
      }, 3000);
    }
  };
  let UpdateUserInfo = async () => {
    let response = await props.AxiosRequest("/api/user/get/self");

    if (response.data.status === "success") {
      // $("#user-info-name").html(response.data.user.first_name + " " + response.data.user.last_name);
      localStorage.setItem("user-full-name", response.data.user.first_name + " " + response.data.user.last_name);
      localStorage.setItem("img-tag", response.data.user.image_link);
      localStorage.setItem("img-link", "https://firmtamer-public-bucket.s3.amazonaws.com/" + response.data.user.image_link);
    }
  };
  // Modal Functions
  const handleOk = () => {
    SubmitLogin();
    setShowSupportModal(false);
  };
  const handleCancel = () => {
    setShowSupportModal(false);
  };
  useEffect(() => {
    if (props?.authToken?.length > 0) UpdateUserInfo();
  }, [props.authToken]);
  return (
    <div>
      <AuthHeader />
      <main className="main h-100 w-100">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
              <div className="d-table-cell align-middle">
                <div className="text-center mt-4">
                  <h1 className="h2">Welcome back</h1>
                  <p className="lead">Sign in to your account to continue</p>
                </div>
                <div className="card">
                  <div className="card-body">
                    <Form onFinish={SubmitLogin}>
                      <div className="m-sm-4">
                        <div className="mb-3">
                          <label>Email</label>
                          <Input
                            className="form-control form-control-lg"
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            value={loginInformation.email}
                            onChange={(e) => {
                              setLoginInformation({ ...loginInformation, email: e.target.value });
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <label>Password</label>
                          <Input
                            className="form-control form-control-lg"
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            value={loginInformation.password}
                            onChange={(e) => {
                              setLoginInformation({ ...loginInformation, password: e.target.value });
                            }}
                          />

                          <div className="row">
                            <div className="col-md-6">
                              <small>
                                <Link to="/auth/forgot-password">Forgot password?</Link>
                              </small>
                            </div>
                            <div className="col-md-6 text-right mt-1">{capsLockWarning ? <h5 className="text-danger">Warning: CapsLock is ON</h5> : null}</div>
                          </div>
                        </div>
                        <div>
                          <div className="form-check align-items-center">
                            <Input type="checkbox" className="form-check-input" name="remember-me" defaultChecked />
                            <label className="form-check-label text-small" htmlFor="customControlInline">
                              &nbsp;Remember me next time
                            </label>
                          </div>
                        </div>
                        <div className="text-center mt-3">
                          <Button type="primary" htmlType="submit" size="large">
                            Sign in
                          </Button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* <div className="modal fade" id="modal-select-company" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: "650px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Please select the company you wish to log into.</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body m-3 mt-0">
              <ReactSelect
                className="mb-2"
                options={this.state.possible_companies.map((pc) => {
                  return { label: pc.name, value: pc.company_id };
                })}
                value={this.state.company_id ? { label: this.state.company_name, value: this.state.company_id } : null}
                onChange={(e) => {
                  this.setState({ company_id: e.value, company_name: e.label }, () => {
                    window.$("#support-sign-in-button").focus();
                  });
                }}
                ref={this.CompanySelectorRef}
              />
              <div className="row">
                <div className="col-md-12 text-right">
                  <button className="btn btn-lg btn-primary" id="support-sign-in-button" onClick={this.handleSubmit}>
                    Sign in
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <Modal title="Support Login" open={showSupportModal} onOk={handleOk} onCancel={handleCancel} okText="Login">
        <Typography.Text strong>Select Company</Typography.Text>
        <Row>
          <Col span={24}>
            <Select
              ref={supportCompaniesSelectRef}
              showSearch
              style={{ width: "100%" }}
              size="large"
              placeholder="Type to search"
              value={supportCompany}
              filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value == input.toLowerCase()}
              options={companies}
              onChange={(e) => {
                setSupportCompany(e);
              }}
            />
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

// export class LoginOld extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       email: "",
//       password: "",
//       capslock: false,
//       redirect: false,
//       company_name: null,
//       company_id: null,
//       possible_companies: [],
//     };
//     this.CompanySelectorRef = React.createRef();
//   }
//   componentDidMount() {
//     this.props.setAuthToken(null);
//     this.props.setRelogRequired(false);
//   }
//   handleSubmit = (event) => {
//     event.preventDefault();
//     if (this.state.email.length === 0) {
//       this.props.MakeNotification("info", "Please enter your email.");
//       return;
//     }
//     if (this.state.password.length === 0) {
//       this.props.MakeNotification("info", "Please enter your password.");
//       return;
//     }
//     let hardware_details = { os: "Unknown OS", os_details: "", browser: "Unknown Browser", screen: { height: 0, width: 0 } };
//     if (navigator.appVersion.indexOf("Win") !== -1) hardware_details.os = "Windows";
//     if (navigator.appVersion.indexOf("Mac") !== -1) hardware_details.os = "MacOS";
//     if (navigator.appVersion.indexOf("X11") !== -1) hardware_details.os = "UNIX";
//     if (navigator.appVersion.indexOf("Linux") !== -1) hardware_details.os = "Linux";
//     if (navigator.appCodeName.indexOf("Moz") !== -1) hardware_details.browser = "Mozilla Firefox";
//     if (navigator.appCodeName.indexOf("Chrome") !== -1) hardware_details.browser = "Google Chrome";
//     if (navigator.appCodeName.indexOf("Edge") !== -1) hardware_details.browser = "Microsoft Edge";
//     if (navigator.appCodeName.indexOf("Explorer") !== -1) hardware_details.browser = "Internet Explorer";
//     if (navigator.appCodeName.indexOf("Opera") !== -1) hardware_details.browser = "Opera";

//     hardware_details.os_details = navigator.oscpu;
//     hardware_details.screen.width = window.screen.availWidth;
//     hardware_details.screen.height = window.screen.availHeight;
//     //
//     axios
//       .post("http://localhost:3001/api/user/login", {
//         ...this.state,
//         preferred_company: this.state.company_id,
//         hardware_details: JSON.stringify(hardware_details),
//       })
//       .then((response) => {
//         // handle success
//         if (response["data"]["status"] === "Error") {
//           this.props.MakeNotification("error", response["data"]["message"] || "Error Logging In. Please check the fields and try again.");
//         }
//         if (response["data"]["status"] === "Info") {
//           this.props.MakeNotification("info", response["data"]["message"] || "Please select the company you wish to log into.");
//           this.setState({ possible_companies: response.data.data }, () => {
//             window.$("#modal-select-company").modal("show");
//             setTimeout(() => {
//               this.CompanySelectorRef.current.focus();
//             }, 449);
//           });
//         }
//         if (response["data"]["status"] === "success") {
//           Cookie.set("x-access-token", response.data.token);
//           Cookie.set("security-settings", JSON.stringify(response.data.security_settings));
//           Cookie.set("x-access-token-expiration", moment().add(response.data.expiration_in_seconds, "seconds"));
//           this.props.setSecuritySettings(response.data.security_settings);
//           this.props.setAuthToken(response.data.token);
//           this.props.setTokenExpirationDate(moment().add(response.data.expiration_in_seconds, "seconds"));
//           this.props.setRelogRequired(false);
//           this.UpdateUserInfo();
//           if ("caches" in window) {
//             caches.keys().then((names) => {
//               // Delete all the cache files
//               names.forEach((name) => {
//                 caches.delete(name);
//               });
//             });
//           }
//           this.props.MakeNotification("success", response["data"]["message"] || "Login successful! Redirecting...");
//           setTimeout(() => {
//             window.location.href = window.location.protocol + "//" + window.location.host + "/clients"; //we do a hard browser setting of the location so that if there are any new updates, a logout and login will cause the broswer to lose it's cache and get the updates.
//             //this.setState({ redirect: true });
//           }, 3000);
//         }
//       })
//       .catch((error) => {
//         //handle errors
//         console.log(error);
//         this.props.MakeNotification("error", "There was an error. Please check your inputs and try again.");
//       })
//       .then((foo) => {
//         // always executed
//       });
//   };

//   UpdateUserInfo = (event) => {
//     var dataObj = { "x-access-token": this.props.authToken };
//     axios
//       .post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/user/get/self", dataObj)
//       .then((response) => {
//         // handle success
//         if (response["data"]["status"] === "success") {
//           $("#user-info-name").html(response["data"]["user"]["first_name"] + " " + response["data"]["user"]["last_name"]);
//           localStorage.setItem("user-full-name", response["data"]["user"]["first_name"] + " " + response["data"]["user"]["last_name"]);
//           localStorage.setItem("img-tag", response["data"]["user"]["image_link"]);
//           localStorage.setItem("img-link", "https://firmtamer-public-bucket.s3.amazonaws.com/" + response["data"]["user"]["image_link"]);
//         }
//       })
//       .catch((error) => {
//         console.log(error);
//       })
//       .then((t) => {});
//   };
//   UpdateEmail = (e) => this.setState({ email: e.target.value });
//   UpdatePassword = (e) => {
//     this.setState({ password: e.target.value });
//     // Also, capslock warning below
//     let password_input = $(e.target);
//     password_input.on("keyup", (l) => {
//       if (l.originalEvent.getModifierState("CapsLock")) {
//         this.setState({ capslock: true });
//       } else {
//         this.setState({ capslock: false });
//       }
//     });
//   };
//   render() {
//     return <></>;
//   }
// }

export default Login;
